import { useQuery } from "react-query";
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { parserNavigator } from "../../../common/utils/parserNavigator";

import { QueryOptions, QueryResult } from "../../../../shared/types/query";
import { parserCalendar } from "../utils/parserCalendar";
import { Calendar } from "../types/calendar";
import { ApiNavigator } from "../../../common/types/apiNavigator";

export function useGetAllCalendars(options?: QueryOptions<ApiNavigator<Calendar>>): QueryResult<ApiNavigator<Calendar>> {
    const http = useHttpClient();

    return useQuery<ApiNavigator<Calendar>>({
        ...options,
        queryKey: ['calendars/getAll', http],
        queryFn: () => {
            return http.request({
                method: 'get',
                url: 'QueueCalendars',
            }).then(result => parserNavigator.fromJson(result.data, parserCalendar.fromJson))
        },
    })
}